const tableOption = function () {
  return {
    stripe: true,
    page: true,
    maxHeight: "98%",
    align: "center",
    header: false,
    index: true,
    selection: true,
    emptyText: "暂无数据",
    column: [
      {
        label: "碳配额(t)",
        prop: "targetQuota",
      },
      {
        label: "目标年份",
        prop: "targetYear",
        search: true,
        clearable: true,
        searchSlot: true,
      },
      {
        label: "基准年份",
        prop: "standardYear",
      },
      {
        label: "相对基准年",
        prop: "changeType",
        type: "select",
        dicData: [
          {
            label: '减少',
            value: '0'
          },
          {
            label: '增加',
            value: '1'
          },
          {
            label: '相等',
            value: '2'
          }
        ],
        formatter: function (row, value) {
          if (Number(value) === 1) {
            return "增加";
          } else if (Number(value) === 0) {
            return "减少";
          } else if (Number(value) === 2) {
            return "相等";
          }
          return "";
        }
      },
      {
        label: "变化配额(t)",
        prop: "changeQuota",
      },
      {
        label: "备注",
        prop: "targetRemark",
      }
    ]
  };
};

export default tableOption;
